// extracted by mini-css-extract-plugin
export default {"frame":"style_frame__u1lGh"};